<template>
    <div class="introMain" style="width: 100%;">
        <Section1 id="section1" />
        <Section2 id="section2" :data="userCount" />
        <Section3 id="section3" />
        <Section4 id="section4" />
        <Section5 id="section5" />
        <Footer id="footer" />
    </div>
</template>
<script>
import Section1 from './content/Section1.vue'
import Section2 from './content/Section2.vue'
import Section3 from './content/Section3.vue'
import Section4 from './content/Section4.vue'
import Section5 from './content/Section5.vue'
import Footer from '../content/Footer.vue'
export default {
    components: {
        Section1,
        Section2,
        Section3,
        Section4,
        Section5,
        Footer
    },
    data() {
        return {
            lastScrollTime: 0,
            activeSection: 1,
            userCount: [85787, 12846],
            isScroll: false,
            isMoving: false,
            timeout: null
        }
    },
    computed: {
        scrollY() {
            return this.$store.state.scrollY
        }
    },
    watch: {
        scrollY() {
            if(this.scrollY == 0) {
                this.isScroll = false
            }
            if(this.scrollY >= window.innerHeight) {
                this.isScroll = true
            }
        }
    },
    methods: {
        handleWheel(e) {
            if((this.scrollY >= 0) && (this.scrollY <= window.innerHeight)) {
                if((this.scrollY == window.innerHeight) && (e.deltaY >= 0)) {
                    return
                } else {
                    e.preventDefault()
                    e.stopImmediatePropagation()
                }
            } else {
                return
            }
            const now = Date.now();
            if(now - this.lastScrollTime < 500) {
                return
            }
            if(!this.isScroll && (e.deltaY > 0)) {
                this.scrollToSection(2)
            } 
            if(this.isScroll && (e.deltaY < 0)) {
                this.scrollToSection(1)
            }
            this.lastScrollTime = now
        },
        scrollToSection(index) {
            window.scrollTo({
                top: index == 1 ? 0 : window.innerHeight,
                behavior: "smooth",
            });
            this.isScroll = true
        },
    },
}
</script>
<style>
    body {
        /* font-family: 'Pretendard' !important; */
    }
    .introMain section p {
        line-height: 1.5;
    }
    .introMain section .mobile_con_wrap {
        width: 100%;
        padding: 0 20px;
    }
    .introMain .arrow_bottom {
        position: absolute;
        bottom: 10px;
        -webkit-animation: flickerAnimation 2s infinite;
        -moz-animation: flickerAnimation 2s infinite;
        -o-animation: flickerAnimation 2s infinite;
        animation: flickerAnimation 2s infinite;
        color: white;
    }
    @keyframes flickerAnimation {
        0% {
            bottom: 30px;
            opacity: 0;
        }
        50% {
            bottom: 20px;
            opacity: 1;
        }

        100% {
            bottom: 30px;
            opacity: 0;
        }
    }
    @-o-keyframes flickerAnimation {
        0% {
            bottom: 30px;
            opacity: 0;
        }
        50% {
            bottom: 20px;
            opacity: 1;
        }

        100% {
            bottom: 30px;
            opacity: 0;
        }
    }
    @-moz-keyframes flickerAnimation {
        0% {
            bottom: 30px;
            opacity: 0;
        }
        50% {
            bottom: 20px;
            opacity: 1;
        }

        100% {
            bottom: 30px;
            opacity: 0;
        }
    }
    @-webkit-keyframes flickerAnimation {
        0% {
            bottom: 30px;
            opacity: 0;
        }
        50% {
            bottom: 20px;
            opacity: 1;
        }

        100% {
            bottom: 30px;
            opacity: 0;
        }
    }
</style>